import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, Box, Grid, List, ListItem } from '@mui/material';

// `heading`: 'h1' when this card is the page (/consumerengagement), 'h2' when
// it's one of several products (/landingpage).
function ConsumerEngagementCard({ heading = 'h2' }) {
  return (
    <Card sx={{ width: '100%', boxShadow: 3 }}>
      {/* Title section */}
      <Box sx={{ p: 2 }}>
        <Typography gutterBottom variant={heading}>
          CONSUMER ENGAGEMENT
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          CREATE YOUR DIGITAL SOUL – Memorable interactions lead to transactions and a customer for life.
        </Typography>
      </Box>

      {/* Content section with media */}
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
        <CardMedia
          component="img"
          sx={{ 
            width: { xs: '100%', sm: 200 }, 
            height: { xs: 200, sm: 'auto' },
            objectFit: 'contain', // Ensure the full image is visible
          }}
          image="/assets/Avatar Pic for Landing Page.png"
          alt="Digital Assistant"
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flexGrow: 1 }}>
          <CardContent>
            <Typography variant="body2" color="text.primary" paragraph>
              Acquiring new customers is very costly. How you acquire and keep prospects engaged in today’s digital environment, is the key to success.
            </Typography>
            <Typography variant="body2" color="text.primary" paragraph>
              Digital Assistants give your brand the power to dialogue with your customers – in real time, at scale, and in their preferred language.
            </Typography>
            <Typography variant="body2" color="text.primary" paragraph>
              Guide your customers to what they’re looking for - information, expertise, and confidence needed to make previously intimidating decisions.
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <List>
                  <ListItem>• Friendly Receptionist</ListItem>
                  <ListItem>• Smart Check-In Assistant</ListItem>
                  <ListItem>• Orientation Guide</ListItem>
                </List>
              </Grid>
              <Grid item xs={12} sm={6}>
                <List>
                  <ListItem>• Web Chat BOT/Share Information</ListItem>
                  <ListItem>• Schedule Appointments</ListItem>
                  <ListItem>• Open House Tours</ListItem>
                </List>
              </Grid>
            </Grid>
          </CardContent>
          <Box sx={{ p: 2, alignSelf: 'flex-end' }}>
            <Button size="small" color="primary">
              LEARN MORE
            </Button>
          </Box>
        </Box>
      </Box>
    </Card>
  );
}

export default ConsumerEngagementCard;
